// pages/confirm/ConfirmPage.jsx

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function ConfirmPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get('status');
  const { t } = useTranslation();

  let message;
  if (status === 'reset_ok') {
    message = t('PasswordResetOk');
  } else if (status === 'mail_ok') {
    message = t('ConfirmValidationLink');
  } else if (status === 'resetlink_ok') {
    message = t('PasswordResetLink');
  } else {
    message = t('UnexpectedError'); // Default message
  }

  return (
    <div className='confirm-container '>
      <p className='custom-confirm'>{message}</p>
    </div>
  );
}

export default ConfirmPage;
